import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import CartDropdown from '../Components/cartDropdown';
import DestinationDropdown from '../Components/destinationDropdown';
import { useLanguage } from '../contexts/LanguageContext';
import { GlobeIcon, MenuIcon, CloseIcon } from '../Components/r4l/icons';

function Header() {
	const location = useLocation();
	const { t } = useTranslation();
	const { currentLanguage, changeLanguage } = useLanguage();
	const [showFallback, setShowFallback] = useState(false);
	const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
	const [showLanguageModal, setShowLanguageModal] = useState(false);
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const [isStuck, setIsStuck] = useState(false);

	useEffect(() => {
		const onScroll = () => setIsStuck(window.scrollY > 4);
		onScroll();
		window.addEventListener('scroll', onScroll, { passive: true });
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		setIsMenuOpen(false);
	}, [location.pathname]);

	// Google Translate initialization
	// useEffect(() => {
	// 	console.log('Header component mounted, initializing Google Translate...');

	// 	// Load Google Translate script
	// 	const script = document.createElement('script');
	// 	script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
	// 	script.async = true;
	// 	script.onload = () => {
	// 		console.log('Google Translate script loaded successfully');
	// 	};
	// 	script.onerror = () => {
	// 		console.error('Failed to load Google Translate script');
	// 		setShowFallback(true);
	// 	};
	// 	document.head.appendChild(script);

	// 	// Initialize Google Translate
	// 	window.googleTranslateElementInit = function () {
	// 		console.log('Google Translate callback triggered');
	// 		try {
	// 			if (window.google && window.google.translate) {
	// 				console.log('Creating Google Translate element...');
	// 				new window.google.translate.TranslateElement({
	// 					// pageLanguage: 'en',
	// 					layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
	// 					// includedLanguages: 'en,fr,nl,ar',  // User's preferred languages
	// 				}, 'google_translate_element');
	// 				console.log('Google Translate element created successfully');
	// 			} else {
	// 				console.log('Google Translate API not available, showing fallback');
	// 				setShowFallback(true);
	// 			}
	// 		} catch (error) {
	// 			console.error('Error initializing Google Translate:', error);
	// 			setShowFallback(true);
	// 		}
	// 	};

	// 	// Set timeout to show fallback if Google Translate doesn't load
	// 	const timeout = setTimeout(() => {
	// 		if (!document.querySelector('#google_translate_element .goog-te-gadget')) {
	// 			console.log('Google Translate not loaded within timeout, showing fallback');
	// 			setShowFallback(true);
	// 		}
	// 	}, 5000);

	// 	// Cleanup function
	// 	return () => {
	// 		clearTimeout(timeout);
	// 		if (document.head.contains(script)) {
	// 			document.head.removeChild(script);
	// 		}
	// 		delete window.googleTranslateElementInit;
	// 	};
	// }, []);

	const toggleLanguageDropdown = () => {
		setIsLanguageDropdownOpen(!isLanguageDropdownOpen);
	};

	const closeLanguageDropdown = () => {
		setIsLanguageDropdownOpen(false);
	};

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (isLanguageDropdownOpen && !event.target.closest('.language-dropdown-container')) {
				setIsLanguageDropdownOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isLanguageDropdownOpen]);

	function getTranslateIframes() {
		return document.querySelectorAll("iframe.skiptranslate");
	}

	function translatePage(langCode) {
	
		changeLanguage(langCode);
		closeLanguageDropdown();
	}

	const openLanguageModal = () => {
		setShowLanguageModal(true);
	};

	const closeLanguageModal = () => {
		setShowLanguageModal(false);
	};

	const isActive = (path) => {
		return location.pathname === path;
	};

	const isDestinationActive = () => {
		return location.pathname.startsWith('/destination');
	};

	const closeMobileNavbar = () => {
		if (!isMenuOpen) return;
		setIsMenuOpen(false);
		setTimeout(() => {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
		}, 100);
	};

	// const handleLanguageChange = (e) => {
	// 	if (e.target.value !== 'en') {
	// 		const currentUrl = window.location.href;
	// 		const translateUrl = `https://translate.google.com/translate?sl=en&tl=${e.target.value}&u=${encodeURIComponent(currentUrl)}`;
	// 		window.open(translateUrl, '_blank');
	// 	}
	// };

	return (
		<>
			<header className={`r4l-header header${isStuck ? ' is-stuck' : ''}${location.pathname === '/' ? ' is-home' : ''}${isMenuOpen ? ' is-menu-open' : ''}`}>
				<div className="r4l-nav-inner">
					<Link className="r4l-logo" to="/" onClick={closeMobileNavbar}>
						<img src={window.getPublicUrl('images/logo.png')} alt="Roam4Less" />
					</Link>

					<nav className={`r4l-nav-links${isMenuOpen ? ' is-open' : ''}`} id="r4l-primary-nav" aria-label="Primary">
						<ul className="r4l-nav-list">
							<DestinationDropdown isActive={isDestinationActive()} onNavItemClick={closeMobileNavbar} />
							<li><Link to="/#plans" onClick={closeMobileNavbar}>{t('r4l.nav.esimPlans')}</Link></li>
							<li><Link to="/#how" onClick={closeMobileNavbar}>{t('r4l.nav.howItWorks')}</Link></li>
							{[
								['/Faq', 'header.nav.faqs'],
								['/blog', 'header.nav.blog'],
								['/speedPolicy', 'header.nav.speedPolicy'],
								['/contactUs', 'header.nav.contactUs']
							].map(([path, key]) => (
								<li key={path} className={isActive(path) ? 'is-active' : ''}>
									<Link to={path} onClick={closeMobileNavbar}>{t(key)}</Link>
								</li>
							))}
						</ul>
					</nav>

					<div className="r4l-nav-tools">
						<CartDropdown />
						<button type="button" className="r4l-lang-btn" onClick={openLanguageModal} aria-label={t('header.languageModal.title')}>
							<GlobeIcon />
							<span>{currentLanguage.toUpperCase()}</span>
						</button>
						<button
							type="button"
							className="r4l-icon-btn r4l-menu-toggle"
							onClick={() => setIsMenuOpen((open) => !open)}
							aria-controls="r4l-primary-nav"
							aria-expanded={isMenuOpen}
							aria-label="Toggle navigation"
						>
							{isMenuOpen ? <CloseIcon /> : <MenuIcon />}
						</button>
					</div>
				</div>
			</header>
			<div className='overlay r4l-overlay'></div>

			<Modal 
				isOpen={showLanguageModal}
				onRequestClose={closeLanguageModal}
				style={{
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						border: 'none',
						borderRadius: '10px',
						padding: '0',
						maxWidth: '950px',
						width: '95%',
						backgroundColor: 'transparent'
					},
					overlay: {
						backgroundColor: 'rgba(0, 0, 0, 0.5)',
						zIndex: 1000
					}
				}}
				contentLabel="Language selector"
				portalClassName="language-selector-modal"
			>
				<div className="paymentsuccess compatibilitymodal">
					<div className="modal-content">
						<div className="modal-header">
							<h3>{t('header.languageModal.title')}</h3>
							<button type="button" onClick={closeLanguageModal} className="close" data-dismiss="modal" aria-label="Close">
								<img src={window.getPublicUrl('images/close.svg')} alt="Close" />
							</button>
						</div>
						<div className="modal-body">
							<div className="device-buttons-container mt-3">
								{(() => {
									const languageTranslations = {
										en: {
											en: 'English', es: 'Spanish', fr: 'French', de: 'German', it: 'Italian',
											pt: 'Portuguese', ja: 'Japanese', nl: 'Dutch', ko: 'Korean', pl: 'Polish',
											ar: 'Arabic', tr: 'Turkish', zh: 'Simplified Chinese'
										},
										es: {
											en: 'Inglés', es: 'Español', fr: 'Francés', de: 'Alemán', it: 'Italiano',
											pt: 'Portugués', ja: 'Japonés', nl: 'Holandés', ko: 'Coreano', pl: 'Polaco',
											ar: 'Árabe', tr: 'Turco', zh: 'Chino Simplificado'
										},
										fr: {
											en: 'Anglais', es: 'Espagnol', fr: 'Français', de: 'Allemand', it: 'Italien',
											pt: 'Portugais', ja: 'Japonais', nl: 'Néerlandais', ko: 'Coréen', pl: 'Polonais',
											ar: 'Arabe', tr: 'Turc', zh: 'Chinois Simplifié'
										},
										de: {
											en: 'Englisch', es: 'Spanisch', fr: 'Französisch', de: 'Deutsch', it: 'Italienisch',
											pt: 'Portugiesisch', ja: 'Japanisch', nl: 'Niederländisch', ko: 'Koreanisch', pl: 'Polnisch',
											ar: 'Arabisch', tr: 'Türkisch', zh: 'Vereinfachtes Chinesisch'
										},
										it: {
											en: 'Inglese', es: 'Spagnolo', fr: 'Francese', de: 'Tedesco', it: 'Italiano',
											pt: 'Portoghese', ja: 'Giapponese', nl: 'Olandese', ko: 'Coreano', pl: 'Polacco',
											ar: 'Arabo', tr: 'Turco', zh: 'Cinese Semplificato'
										},
										pt: {
											en: 'Inglês', es: 'Espanhol', fr: 'Francês', de: 'Alemão', it: 'Italiano',
											pt: 'Português', ja: 'Japonês', nl: 'Holandês', ko: 'Coreano', pl: 'Polonês',
											ar: 'Árabe', tr: 'Turco', zh: 'Chinês Simplificado'
										},
										ja: {
											en: '英語', es: 'スペイン語', fr: 'フランス語', de: 'ドイツ語', it: 'イタリア語',
											pt: 'ポルトガル語', ja: '日本語', nl: 'オランダ語', ko: '韓国語', pl: 'ポーランド語',
											ar: 'アラビア語', tr: 'トルコ語', zh: '簡体字中国語'
										},
										nl: {
											en: 'Engels', es: 'Spaans', fr: 'Frans', de: 'Duits', it: 'Italiaans',
											pt: 'Portugees', ja: 'Japans', nl: 'Nederlands', ko: 'Koreaans', pl: 'Pools',
											ar: 'Arabisch', tr: 'Turks', zh: 'Vereenvoudigd Chinees'
										},
										ko: {
											en: '영어', es: '스페인어', fr: '프랑스어', de: '독일어', it: '이탈리아어',
											pt: '포르투갈어', ja: '일본어', nl: '네덜란드어', ko: '한국어', pl: '폴란드어',
											ar: '아랍어', tr: '터키어', zh: '중국어 간체'
										},
										pl: {
											en: 'Angielski', es: 'Hiszpański', fr: 'Francuski', de: 'Niemiecki', it: 'Włoski',
											pt: 'Portugalski', ja: 'Japoński', nl: 'Holenderski', ko: 'Koreański', pl: 'Polski',
											ar: 'Arabski', tr: 'Turecki', zh: 'Chiński Uproszczony'
										},
										ar: {
											en: 'الإنجليزية', es: 'الإسبانية', fr: 'الفرنسية', de: 'الألمانية', it: 'الإيطالية',
											pt: 'البرتغالية', ja: 'اليابانية', nl: 'الهولندية', ko: 'الكورية', pl: 'البولندية',
											ar: 'العربية', tr: 'التركية', zh: 'الصينية المبسطة'
										},
										tr: {
											en: 'İngilizce', es: 'İspanyolca', fr: 'Fransızca', de: 'Almanca', it: 'İtalyanca',
											pt: 'Portekizce', ja: 'Japonca', nl: 'Hollandaca', ko: 'Korece', pl: 'Lehçe',
											ar: 'Arapça', tr: 'Türkçe', zh: 'Basitleştirilmiş Çince'
										},
										zh: {
											en: '英语', es: '西班牙语', fr: '法语', de: '德语', it: '意大利语',
											pt: '葡萄牙语', ja: '日语', nl: '荷兰语', ko: '韩语', pl: '波兰语',
											ar: '阿拉伯语', tr: '土耳其语', zh: '简体中文'
										}
									};

									const currentTranslations = languageTranslations[currentLanguage] || languageTranslations.en;

									return [
										{ key: 'en', label: 'English' },
										{ key: 'es', label: 'Español' },
										{ key: 'fr', label: 'Français' },
										{ key: 'de', label: 'Deutsch' },
										{ key: 'it', label: 'Italiano' },
										{ key: 'pt', label: 'Português' },
										{ key: 'ja', label: '日本語' },
										{ key: 'nl', label: 'Netherlands' },
										{ key: 'ko', label: '한국어' },
										{ key: 'pl', label: 'Polski' },
										{ key: 'ar', label: 'العربية' },
										{ key: 'tr', label: 'Türkçe' },
										{ key: 'zh', label: '中文（简体）' }
									].map((lang) => (
									<button
										key={lang.key}
										className={`device-compatibility-btn ${currentLanguage === lang.key ? 'selected-language' : ''}`}
										onClick={() => {
											translatePage(lang.key);
											closeLanguageModal();
										}}
										style={{
											display: 'inline-flex',
											width: '268px',
											height: '60px',
											marginRight: '10px',
											marginBottom: '10px',
											padding: '12px 16px',
											border: currentLanguage === lang.key ? '2px solid #FF7400' : '1px solid #ddd',
											borderRadius: '20px',
											backgroundColor: currentLanguage === lang.key ? '#fff5f0' : '#fff',
											color: '#333',
											fontSize: '14px',
											cursor: 'pointer',
											transition: 'all 0.3s ease',
											textAlign: 'left',
											position: 'relative',
											alignItems: 'center'
										}}
										onMouseEnter={(e) => {
											if (currentLanguage !== lang.key) {
												e.target.style.backgroundColor = '#f8f9fa';
												e.target.style.borderColor = '#ddd';
											}
										}}
										onMouseLeave={(e) => {
											if (currentLanguage !== lang.key) {
												e.target.style.backgroundColor = '#fff';
												e.target.style.borderColor = '#ddd';
											}
										}}
									>
										<div style={{ textAlign: 'left', lineHeight: '1.2' }}>
											<div style={{ fontWeight: 'bold', fontSize: '14px' }}>{lang.label}</div>
											<div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>{currentTranslations[lang.key]}</div>
										</div>
										<span style={{
											position: 'absolute',
											right: '6px',
											top: '50%',
											transform: 'translateY(-50%)',
											color: '#ddd',
											fontSize: '12px'
										}}>
 										→
										</span>
									</button>
									));
								})()}
							</div>
						</div>
						{/* <div className="modal-footer border-0 pt-0 justify-content-start">
							<button
								type="button"
								className="btn view-all get-sim m-0"
								onClick={closeLanguageModal}
								style={{
									width: '54px',
									padding: '9px',
									fontSize: '14px'
								}}
							>
								{t('header.languageModal.ok')}
							</button>
						</div> */}
					</div>
				</div>
			</Modal>
		</>
	);
}

export default Header;